var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreenBigVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4551 0.32666C13.8951 0.32666 0.455078 13.7667 0.455078 30.3267C0.455078 46.8867 13.8951 60.3267 30.4551 60.3267C47.0151 60.3267 60.4551 46.8867 60.4551 30.3267C60.4551 13.7667 47.0151 0.32666 30.4551 0.32666ZM24.4551 45.3267L9.45508 30.3267L13.6851 26.0967L24.4551 36.8367L47.2251 14.0667L51.4551 18.3267L24.4551 45.3267Z",
    fill: "#198754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenBigVector);
export default __webpack_public_path__ + "static/media/CheckGreenBigVector.855abab41d172a8aefd3e03345943485.svg";
export { ForwardRef as ReactComponent };